import React from 'react'
import './../../App.css'
import './servicedetail.css'
export default function Servicedetail(props) {
  const technologies = [...props.technologies];
  console.log(...technologies)
  return (
    <section className='ptb-100'>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <div className="services_details_img">
              <img src={props.serviceimg} alt="" />
            </div>
            <div className="services_details_description">
              <h3>About this Services</h3>
              <p>{props.servicesabout}</p>
              <h3>Technologies That We Use</h3>
              <ul className="technologies_features" >
              {technologies.map(technology => {
                return(
                  <li key={technology}><span>{technology}</span></li>
                )
              })}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 justify-content-start">
            <div className="services-details-info">
              <div className="services-contact-info">
                <h3>Contact Info</h3>
                <ul>
                  <li>
                    <div className="icon">
                      <i className='bx bx-user-pin'></i>
                    </div>
                    <span>Phone :</span>
                    <a href="tel:+92-33-22511711">+92-33-22511711</a>
                  </li>
                  <li>
                    <div className="icon">
                      <i className='bx bx-map'></i>
                    </div>
                    <span>Location :</span>
                    1st Floor Kallar House, North Colony, Mithi, Sindh Pakistan
                  </li>
                  <li>
                    <div className="icon">
                      <i className='bx bx-envelope'></i>
                    </div>
                    <span>Email :</span>
                    <a href="mailto:info@ihunar.com">info@ihunar.com</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
